import { render, staticRenderFns } from "./TabExpired.vue?vue&type=template&id=6f921b94"
import script from "./TabExpired.vue?vue&type=script&lang=js"
export * from "./TabExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports